<div class="auth-form-wrapper">
  <div class="auth-logo">
    <div class="flex flex-row gap-3 items-center">
      <img src="logo-gate-white.svg" alt="logo" />
    </div>
    <p class="mt-2">{{ 'ADMIN_SYSTEM_NAME' | localization }}</p>
  </div>

  <div class="auth-form">
    <div class="flex flex-row justify-between">
      <h1 class="text-3xl mb-7">{{ 'AUTH_LOGIN_PAGE_TITLE' | localization }}</h1>
      <pkp-g-language-selector></pkp-g-language-selector>
    </div>
    <ui-form [form]="form" [config]="formConfig" (enterPressed)="onSubmit()"> </ui-form>

    <ui-button
      type="primary"
      [block]="true"
      (click)="onSubmit()"
      [disabled]="isFormInvalid"
      [loading]="isFormSubmitting"
      >{{ 'AUTH_LOGIN_SUBMIT_BUTTON' | localization }}
    </ui-button>
  </div>
</div>

<img class="auth-bg" src="assets/images/bg.webp" alt="uims-bg" />
